// Copyright (c) 2017 Deere & Company

import DE from './de';
import EN from './en';
import ES from './es';
import FI from './fi';
import FR from './fr';
import IT from './it';
import PL from './pl';
import PT from './pt';
import RU from './ru';
import SV from './sv';
import TR from './tr';
import ZH from './zh';
export const getMessages = () => ({
  DE,
  EN,
  ES,
  FI,
  FR,
  IT,
  PL,
  PT,
  RU,
  SV,
  TR,
  ZH
});